import React from 'react'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import AsyncSelectCreatable from 'react-select/async-creatable'

type Props = {
	type: string
	[key: string]: any
}

const ReactSelectWrapper = (props: Props) => {
	const { type, ...sharedRest } = props

	const defaults = {
		styles: {
			clearIndicator: (provided) => ({
				...provided,
				background: 'none',
				border: 'rgb(229, 231, 235)',
			}),
		},
		className:
			'relative react-select-container bg-white flex-grow ' +
			props?.addClassName,
		classNamePrefix: 'react-select',
		menuPosition: 'fixed',
	}

	switch (type) {
		case 'AsyncSelect':
			return <AsyncSelect {...defaults} {...sharedRest} />

		case 'AsyncSelectCreatable':
			return <AsyncSelectCreatable {...defaults} {...sharedRest} />

		case 'Select':
		default:
			return <Select {...defaults} {...sharedRest} />
	}
}

ReactSelectWrapper.isFormable = true

export default ReactSelectWrapper
